<template>
  <v-sheet class="terms">
    <v-row>
      <v-col>
        <h1 class="mt-10 mb-15 text-center">TERMS OF SERVICE</h1>

        <p>
          These Terms of Service (“Agreement”) are agreed to between Hire Next
          Generation LLC (“Company”) and you, or, if you represent an entity or
          other organization, that entity or organization (in either case
          “You”).
        </p>

        <p>
          Company offers an online service platform known as HRNG, or Hire Next
          Generation (the “Platform”) for use with job candidates to create
          video profiles of themselves. The Platform provides You with the
          ability to access and use information, data, and other content
          (“Content”) on a variety of topics, as well as additional services,
          functionality, and resources made available through the Platform
          (“Services”).
        </p>

        <p>
          The Services and Content available through the Platform may offer You
          certain advice or tips on how better to prepare yourself for job
          placement. You acknowledge and agree that the Platform and all
          Services and Content are designed and intended solely to assist You in
          recognizing certain traits about yourself, and not as a replacement
          for individualized, personal advice tailored to your specific line of
          work or job in which you seek to apply.
        </p>

        <p>
          Regardless of Your use of the Platform, You maintain sole
          responsibility any work product you may crate and/or submit to the
          Company or potential employers.
        </p>

        <p>
          YOU AGREE THAT YOU ARE SOLELY RESPONSIBLE FOR DETERMINING THE
          APPROPRIATENESS AND SUITABILITY OF THE PLATFORM FOR YOU AND FOR USING
          THE PLATFORM TO OBTAIN ASSISTANCE BASED ON YOUR PARTICULAR
          CIRCUMSTANCES.
        </p>

        <p>
          This Agreement is entered into as of the earliest date You first
          access or use the Platform (the “Effective Date”). This Agreement
          includes all terms and conditions below. This Agreement applies to the
          Platform, including all Content and Services available through the
          Platform. This Agreement is the complete and exclusive agreement
          between You and Company regarding Your access to and use of the
          Platform or any Content or Services.
        </p>

        <p>
          This Agreement supersedes any prior agreement or proposal, oral or
          written, and any other communications between You and Company relating
          to Your use of the Platform or any Content or Services. PLEASE
          CAREFULLY READ THIS AGREEMENT.
        </p>

        <p>
          PLEASE CAREFULLY READ THIS AGREEMENT. BY ACCESSING OR USING THE
          PLATFORM, INCLUDING ANY CONTENT OR SERVICES, OR BY CLICKING A BOX THAT
          STATES THAT YOU ACCEPT OR AGREE TO THESE TERMS, YOU AGREE THAT YOU
          HAVE READ AND AGREE TO BE BOUND BY THIS AGREEMENT.
        </p>

        <p>
          1. Definitions. Terms used in this Agreement have the definitions
          given in this Agreement or, if not defined in this Agreement, have
          their plain English meaning as commonly interpreted in the United
          States.
        </p>

        <p>
          2. Term. This Agreement will be effective upon the Effective Date and
          continue until such time as the Company or You terminate your use of
          the Platform.
        </p>

        <p>
          3. Modifications. Company reserves the right, at any time, to modify
          the Platform and any portion of the Content or Services, with or
          without notice to You, by making those modifications available on the
          Platform. Company also reserves the right, at any time, to modify the
          terms of this Agreement. Company will inform You of the presence of
          any changes to this Agreement by posting those changes on the Platform
          or by providing You with notice through the Platform. Any
          modifications will be effective 30 days following posting on the
          Platform or delivery of such notice through the Platform, except in
          the case of a legally required modification which will be effective
          upon posting. You may terminate this Agreement as set forth below if
          you object to any such modifications. However, You will be deemed to
          have agreed to any and all modifications through Your continued use of
          the Platform, Content, or Services following such notice period.
        </p>

        <p>
          4. Eligibility. The Platform and all Content and Services are intended
          for use by individuals 18 years of age and older. If You are not 18
          years of age or older, You agree not to access or use the Platform or
          any Content or Services. You agree not to allow any individual under
          18 years of age to access or use the Platform, whether or not You are
          the parent or guardian of that individual
        </p>

        <p>5. Accounts.</p>

        <p>
          5.1 Accounts. Subject to the terms of this Agreement, You may be
          permitted to access certain Content and Services through the Platform
          without establishing an account on the Platform. However, access to
          the Platform generally requires that You register as a user of the
          Platform (a “User”) and establish a user account on the Platform (an
          “Account”). Approval of Your request to establish and maintain any
          Account will be at the sole discretion of Company.
        </p>

        <p>
          5.2 Account IDs. You will be responsible for establishing and
          maintaining the user identification and password for Your Account (the
          “Account ID”). Each Account is for Your personal use and all Account
          IDs are personal in nature. Each Account ID may be used only by You
          alone. You may not share or transfer Your Account or Account ID or
          provide a third party with the right to access your Account or Account
          ID. You are solely responsible for all use of the Platform and all
          Content and Services through Your Account. You will ensure the
          security and confidentiality of Your Account ID and will notify
          Company immediately if Your Account ID is lost, stolen or otherwise
          compromised. You are fully responsible for all liabilities and damages
          incurred through the use of Your Account or under Your Account ID
          (whether lawful or unlawful) and any actions taken through Your
          Account or under Your Account ID will be deemed to have been lawfully
          completed by You.
        </p>

        <p>
          5.3 Account Information. In connection with establishing an Account,
          You will be asked to submit certain information about Yourself. You
          are solely responsible for the Account Information for Your Account.
          You agree that: (a) all Account Information You provide will be
          accurate, complete and current; and (b) You will maintain and promptly
          update all Account Information as necessary to keep it accurate,
          complete, and current. You may not: (i) select or use an Account ID of
          another person with the intent to impersonate that person; and (ii)
          use an Account ID that Company, in its sole discretion, deems
          offensive.
        </p>

        <p>
          5.4 Account Confirmation. You are solely responsible for confirming
          the set-up and configuration of Your in all respects and for making
          all changes and updates thereto through this Agreement.
        </p>

        <p>6. Access.</p>

        <p>
          6.1 To the Platform. You may access the Platform through the website
          located at www.hirenextgeneration.com (this website and any other
          websites operated by Company bearing this Agreement, each a “Site”) or
          using mobile and online applications provided by and on behalf of
          Company (each, an “Application,” and each Site and Application forming
          a part of the “Platform” for purposes of this Agreement). Subject to
          Your compliance with this Agreement, Company will permit You to access
          and use the Platform solely for lawful purposes and only in accordance
          with the terms of this Agreement. You are solely responsible for
          obtaining and maintaining all equipment, facilities, and connectivity
          required to access or use the Platform and each Site or Application,
          in each case as necessary to meet Your requirements based on Your
          particular circumstances.
        </p>

        <p>
          6.2 To Applications. Subject to Your compliance with this Agreement
          and any other terms and conditions accompanying each Application,
          Company will permit You to download and install Applications and
          operate those Applications solely for the purpose of using and
          accessing the Platform. You may install each Application only on
          computers, smart phones, tablets, or other applicable devices owned or
          controlled by You and used only for Your own personal and
          non-commercial purposes in accordance with this Agreement and any
          applicable terms and conditions accompanying the Application or
          otherwise provided to You by Company. Except as expressly set forth in
          the previous sentence, You are granted no licenses or other rights in
          or to any Application. You agree not to use, modify, reproduce,
          perform, display, create derivative works from, republish, post,
          transmit, participate in the transfer or sale of, distribute, or in
          any way exploit or utilize any Application other than as expressly
          permitted in this Agreement or any other agreement You are required to
          agree to before being given access to any Application.
        </p>

        <p>
          6.3 To Other Users. The Platform may allow you to link, connect or
          otherwise communicate with other users of the Platform. By linking,
          connecting, or communicating with other Users, You are agreeing to
          allow those Users to communicate directly with You through the
          Platform. You agree that You are solely responsible for all
          communications between You and any other User through the Platform.
          Your extension or acceptance of a link, connection or other
          communication with another User will serve as Your affirmative “opt
          in” to the disclosure of any of Your Content (as defined below) or
          other data or information (which may include Your personally
          identifiable information) that You provide to that other User. You
          agree that Your links, connections or other communications with other
          Users through the Platform will not: (a) violate this Agreement,
          including, without limitation, the Privacy Policy; (b) violate any
          applicable international, federal, state, and local treaties, laws,
          rules, regulations, and ordinances (“Laws”), including, without
          limitation, any rules of professional conduct or of licensing bodies;
          (c) be libelous, defamatory, obscene, abusive, pornographic,
          threatening, or an invasion of privacy; (d) constitute an
          infringement, misappropriation or violation of the IPR (as defined
          below) or other rights of any third party; (e) be illegal in any way
          or advocate illegal activity; (f) be false, misleading or inaccurate;
          (g) be considered junk mail, spam, a part of a pyramid scheme, a
          disruptive commercial message or disruptive advertisement; (h) cause
          the publication or release of any material non-public data or
          information or (i) constitute the unauthorized practice of medicine,
          therapy, law or other professional service.
        </p>

        <p>
          6.4 To Content. You will be provided with access to a variety of
          Content through the Platform, including, text, audio, video,
          photographs, maps, illustrations, graphics, and other data,
          information and media. Unless otherwise noted on the Platform, all
          Content available through the Platform (“Platform Content”) is owned
          by Company and Company’s other third party providers. All Platform
          Content is provided for informational purposes only and You are solely
          responsible for verifying the accuracy, completeness and applicability
          of all Platform Content and for Your use of any Platform Content.
          Subject to Your compliance with this Agreement, You may access the
          Platform Content solely for Your own personal purposes in connection
          with Your use of the Platform. You will not, and will not permit any
          third party to: (a) alter, modify, reproduce, or create derivative
          works of any Platform Content; (b) distribute, sell, resell, lend,
          loan, lease, license, sublicense or transfer any Platform Content; or
          (c) alter, obscure or remove any copyright, trademark or any other
          notices that are provided on or in connection with any Platform
          Content. Company has not verified the accuracy of, and will not be
          responsible for any errors or omissions in, any Platform Content.
          Without limiting the foregoing, Company will not be held liable to You
          or any other third party for any Content, including Your Content (as
          defined below), under a Federal Law called the Communications Decency
          Act or CDA, 47 U.S.C. § 230. Except as set forth in this Agreement,
          You are granted no licenses or other rights in or to any Platform
          Content, or any IPR (as defined below) therein or related thereto. If
          You would like to use any Platform Content in a manner not permitted
          by this Agreement, please contact Company.
        </p>

        <p>
          6.5 To Third-Party Services. The Platform may provide You with the
          choice to access certain Services developed, provided or maintained by
          other third party service providers (each, a “Third Party Service”).
          In addition to the terms of this Agreement, Your access to and use of
          any Third Party Service is also subject to any other agreement You may
          agree to before being given access to the Third Party Service (each, a
          “Third Party Service Agreement”). The terms of any Third Party Service
          Agreement (which may include payment of additional fees) will apply to
          the applicable Third Party Services provided under that Third Party
          Service Agreement in addition to the terms of this Agreement but will
          not apply to any other Services You may access through the Platform.
          Except as set forth in this Agreement, the terms of this Agreement and
          that Third Party Service Agreement. Company TAKES NO RESPONSIBILITY
          FOR ANY THIRD PARTY SERVICE AND YOUR ACCESS TO AND USE OF ANY THIRD
          PARTY SERVICE IS SOLELY AS SPECIFIED IN EACH APPLICABLE THIRD PARTY
          AGREEMENT.
        </p>

        <p>
          6.6 To Third Party Information. The Platform may provide You with
          certain access to data and other information about Users of the
          Platform and other third parties (“User Information”). The User
          Information may contain sensitive personal information regarding those
          Users and other third parties. You agree that You will only collect,
          use and disclose User Information in strict accordance with this
          Agreement and the current Privacy Policy relating to the Platform
          available at www.hirenextgeneration.com (“Privacy Policy”). Except as
          expressly provided in this Agreement and the Privacy Policy, You are
          granted no licenses or rights in or to any User Information or any IPR
          therein or related thereto.
        </p>

        <p>
          6.7 To Mobile Services. The Services offered through the Platform may
          include certain messaging and communications services available
          through Your mobile telephone and other mobile device (“Mobile
          Services”). By accessing or using any Mobile Services, You consent to
          receiving messages including Content through any applicable mobile
          device You specify through the Platform (“Mobile Device”) and to
          providing Content from Your Mobile Device to other Users through the
          Platform. As to any Mobile Device You use in connection with any
          Mobile Services, You acknowledge that You are the authorized account
          holder for that Mobile Device. All Mobile Services and the messages
          and Content received, provided, transmitted, exchanged, or otherwise
          made available through the Mobile Services are subject to each
          applicable Third Party Service Agreement with the third party service
          providers used by Company to deliver those Services.
        </p>

        <p>
          7. Your Content. You are solely responsible for all Content that You
          may provide or upload to the Platform or otherwise generate through
          Your use of or access to the Platform (“Your Content”). As between You
          and Company, You retain ownership of Your Content. However, subject to
          any limitations included in the Privacy Policy, You grant Company a
          nonexclusive, royalty-free, perpetual, irrevocable, and fully
          sublicensable (including, without limitation, to Users and other third
          parties) right to use, copy, store, reproduce, modify, display, adapt,
          publish, translate, create derivative works from, distribute, and
          display (“Use”) Your Content for purposes of providing the Services to
          You and for use in making enhancements and improvement to the
          Platform. You represent and warrant that none of Your Content or the
          use of Your Content by Company: (1) violates this Agreement, the
          Privacy Policy, or any requirements under applicable Laws; (2) is
          libelous, defamatory, obscene, abusive, pornographic, threatening, or
          an invasion of privacy; (3) constitutes an infringement,
          misappropriation or violation of the IPR or other rights of any third
          party; (4) is illegal in any way or advocates illegal activity; (5) is
          an advertisement or solicitation of funds, goods, or services (unless
          You have entered into a separate Advertiser Agreement with Company);
          (6) is false, misleading or inaccurate; (7) is or could be considered
          junk mail, spam, a part of a pyramid scheme, a disruptive commercial
          message or disruptive advertisement; or (8) constitutes the
          unauthorized practice of medicine, law, therapy or other professional
          service. Company is not responsible or liable for any deletion,
          correction, destruction, damage, loss or failure to store, restore or
          back-up any of Your Content. You agree that You have all right, title,
          interest and consent in Your Content necessary to allow Company to Use
          Your Content as set forth in the rights and licenses You grant to
          Company under this Agreement.
        </p>

        <p>8. Termination and Effect.</p>

        <p>
          8.1 Termination. This Agreement may be terminated by Company, at any
          time, in Company’s sole discretion: (a) upon any breach or threatened
          breach by You of this Agreement; or (b) at any for any reason or no
          reason, upon notice to You. You may terminate this Agreement at any
          time upon notice to Company or by deleting Your Account as may be
          permitted through the Platform.
        </p>

        <p>
          8.2 Effect. Termination of this Agreement will terminate all of Your
          Accounts on the Platform. Upon termination or expiration of this
          Agreement by Company except for your uncured breach of this Agreement,
          each of Your Accounts will be converted into a “read-only” format for
          a period of 30 days. During this 30-day period, You may be permitted
          to access Your Accounts solely for purposes of retrieving Your Content
          from Your Accounts. Following such 30-day period, Company may
          thereafter terminate all access to Your Accounts and delete or archive
          any of Your Content held by Company at any time. Upon termination or
          expiration of this Agreement for any reason: (a) all rights and
          subscriptions granted to You under this Agreement will terminate; (b)
          You will immediately cease all use of and access to the Platform,
          including all Content and Services; (c) You will immediately delete
          any Applications You have downloaded or installed prior to
          termination; and (d) You will immediately either return to Company or,
          at Company’s discretion, destroy any Content of Company and any other
          information related to this Agreement in Your possession or control.
        </p>

        <p>
          9. Suspension. Without limiting Company’s right to terminate this
          Agreement, Company may also suspend Your access to Your Account and
          the Platform or any Content or Services (including Your Content), with
          or without notice to You, upon any actual, threatened or suspected
          breach of this Agreement or applicable Law or upon any other conduct
          deemed by Company, in its sole discretion, to be inappropriate or
          detrimental to the Platform, Company, or other User or third party.
        </p>

        <p>
          10. Platform Technology. The Platform, and the data, information,
          databases, software, hardware and other technology used by or on
          behalf of Company to operate the Platform, and the structure,
          organization, and underlying data, information and software code
          thereof (collectively, the “Technology”), constitute valuable trade
          secrets of Company. You will not, and will not permit any third party
          to: (1) access or attempt to access the Technology except as expressly
          provided in this Agreement; (2) use the Technology in any unlawful
          manner or in any other manner that could damage, disable, overburden
          or impair the Technology; (3) use automated scripts to collect
          information from or otherwise interact with the Technology; (4) alter,
          modify, reproduce, create derivative works of the Technology; (5)
          distribute, sell, resell, lend, loan, lease, license, sublicense or
          transfer any of Your rights to access or use the Technology or
          otherwise make the Technology available to any third party; (6)
          reverse engineer, disassemble, decompile, or otherwise attempt to
          derive the method of operation of the Technology; (7) attempt to
          circumvent or overcome any technological protection measures intended
          to restrict access to any portion of the Technology; (8) monitor the
          availability, performance or functionality of the Technology; or (9)
          interfere with the operation or hosting of the Technology.
        </p>

        <p>
          11. Ownership. Company retains all right, title and interest,
          including, without limitation, all IPR (as defined below), in and to
          the Technology and any additions, improvements, updates and
          modifications thereto. You receive no ownership interest in or to the
          Technology and You are not granted any right or license to use the
          Technology itself, apart from Your ability to access the Platform,
          under this Agreement. The Company name, logo and all product and
          service names associated with the Platform are trademarks of Company
          and its providers and You are granted no right or license to use them.
          For purposes of this Agreement, “IPR” means all intellectual property
          rights, proprietary rights, rights of publicity, rights of privacy,
          and any and all other legal rights protecting data, information or
          intangible property throughout the world, including, without
          limitation, any and all copyrights, trademarks, service marks, trade
          secrets, patent rights, moral rights, sui generis rights in databases,
          and contract rights.
        </p>

        <p>12. Representations and Warranties.</p>

        <p>
          12.1 Authority. You represent and warrant to Company that: (a) You
          have the legal right and authority to enter into this Agreement; (b)
          this Agreement forms a binding legal obligation on Your behalf; and
          (c) You have the legal right and authority to perform Your obligations
          under this Agreement and to grant the rights and licenses described in
          this Agreement.
        </p>

        <p>
          12.2 Compliance with Laws. You acknowledge that (a) the Platform is
          provided as a tool for use in assisting You in Your job pursuit
          efforts and that You remain solely responsible for all work product
          you create and deliver to any prospective employers; (b) the Platform
          is a general purpose service and is not specifically designed to
          facilitate compliance with any specific Law; and (c) You will access
          and use the Platform in compliance with all Laws applicable to You,
          Your Content and any other Platform Content You may access through the
          Platform. Company is not responsible for notifying You of any such
          Law, enabling Your compliance with any such Law, or for Your failure
          to comply. You represent and warrant to Company that Your Content,
          Your Services, and Your use of and access to the Platform, including
          any Platform Content, will comply with all applicable Laws and will
          not cause Company itself or any other User or Expert to violate any
          applicable Laws, including, without limitation, the Health Insurance
          Portability and Accountability Act of 1996 or the Health Information
          Technology for Economic and Clinical Health (HITECH) Act (enacted as
          part of the American Recovery and Reinvestment Act of 2009).
        </p>

        <p>13. Disclaimers.</p>

        <p>
          13.1 No Professional Advice. THE PLATFORM DOES NOT PROVIDE MEDICAL,
          LEGAL, FINANCIAL OR OTHER PROFESSIONAL ADVICE AND IS NOT INTENDED TO
          BE A SUBSTITUTE FOR MEDICAL, LEGAL, FINANCIAL OR OTHER PROFESSIONAL
          ADVICE OR RECOMMENDATIONS. ALL CONTENT MADE AVAILABLE TO YOU THROUGH
          THE PLATFORM, INCLUDING, WITHOUT LIMITATION, CONTENT PROVIDED BY
          COMPANY, ANY OTHER USERS, OR ANY OTHER SOURCE, IS FOR INFORMATIONAL
          PURPOSES AND GENERAL GUIDANCE ONLY. YOUR USE OF THE SERVICES AND ANY
          INTERACTIONS YOU MAY HAVE WITH COMPANY OR ANY OTHER USER OR THIRD
          PARTY THROUGH THE PLATFORM DO NOT CREATE A PROFESSIONAL RELATIONSHIP
          AND DO NOT CREATE ANY PRIVACY INTERESTS OTHER THAN THOSE DESCRIBED IN
          THE PRIVACY POLICY. NEITHER COMPANY NOR ANY USER RECOMMENDS OR
          ENDORSES ANY CONTENT OR ANY SPECIFIC PRODUCTS, SERVICES, PROCEDURES,
          OPINIONS OR RECOMMENDATIONS THAT MAY BE INCLUDED ON THE PLATFORM. YOUR
          RELIANCE ON ANY CONTENT APPEARING ON THE PLATFORM IS SOLELY AT YOUR
          OWN RISK.
        </p>

        <p>
          13.2 No Additional Warranties. THE PLATFORM, CONTENT, AND SERVICES ARE
          PROVIDED “AS IS” AND “AS AVAILABLE.” COMPANY AND ITS AFFILIATES DO NOT
          WARRANT OR GUARANTEE THE ACCURACY, COMPLETENESS, ADEQUACY OR CURRENCY
          OF THE PLATFORM OR ANY CONTENT OR SERVICES AND DO NOT ENDORSE THE
          VIEWS OR OPINIONS THAT MAY BE EXPRESSED IN THE PLATFORM CONTENT OR
          OTHER DATA, INFORMATION OR CONTENT THAT MAY BE PROVIDED THROUGH THE
          PLATFORM. COMPANY AND ITS AFFILIATES EXPRESSLY DISCLAIM ANY AND ALL
          WARRANTIES AND REPRESENTATIONS OF ANY KIND WITH REGARD TO THE
          PLATFORM, CONTENT, SERVICES AND OTHER SUBJECT MATTER OF THIS
          AGREEMENT, WHETHER EXPRESS, IMPLIED OR STATUTORY, INCLUDING, WITHOUT
          LIMITATION, ANY WARRANTIES OF FITNESS FOR A PARTICULAR PURPOSE,
          MERCHANTABILITY, TITLE OR NON-INFRINGEMENT. NO ORAL OR WRITTEN
          INFORMATION OR ADVICE GIVEN BY COMPANY, ITS EMPLOYEES, AFFILIATES OR
          AGENTS WILL INCREASE THE SCOPE OF, OR CREATE ANY NEW WARRANTIES IN
          ADDITION TO, THE WARRANTIES EXPRESSLY SET FORTH IN THIS SECTION.
        </p>

        <p>
          14. Indemnity. You hereby agree to indemnify, defend, and hold
          harmless Company and its officers, directors, shareholders,
          affiliates, employees, agents, contractors, assigns, Users, customers,
          providers, licensees, and successors in interest (“Indemnified
          Parties”) from any and against all claims, losses, liabilities,
          damages, fees, expenses and costs (including attorneys’ fees, court
          costs, damage awards, and settlement amounts) that result from any and
          against all claim or allegation against any Indemnified Party arising
          in any manner from: (1) Your access to or use of the Platform.
          Including any Content or Services; (2) Your content or any access to
          or use thereof; (3) any access to or use of Your Content by any other
          users; (4) Your collection, use and disclosure of any User
          Information, and (5) Your breach of any provision of this Agreement,
          including any representation or warranty. Company will provide You
          with notice of any such claim or allegation, and Company will have the
          right to participate in the defense of any such claim at its expense.
        </p>

        <p>
          15. Limitation on Liability. COMPANY WILL NOT BE LIABLE FOR ANY
          DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY OR CONSEQUENTIAL
          DAMAGES, HOWEVER CAUSED, UNDER ANY THEORY OF LIABILITY, WHETHER IN
          CONTRACT, STRICT LIABILITY OR TORT (INCLUDING NEGLIGENCE OR
          OTHERWISE), ARISING IN CONNECTION WITH OR OUT OF THE USE OF THE
          PLATFORM, CONTENT OR SERVICES, EVEN IF COMPANY HAS BEEN ADVISED OF THE
          POSSIBILITY OF SUCH DAMAGES, INCLUDING, WITHOUT LIMITATION, ANY LOSS
          OF YOUR CONTENT, OPPORTUNITY, REVENUES, PROFITS OR REPUTATION,
          BUSINESS INTERRUPTION, OR PROCUREMENT OF SUBSTITUTE CONTENT, GOODS OR
          SERVICES. COMPANY’S TOTAL CUMULATIVE LIABILITY IN CONNECTION WITH THIS
          AGREEMENT AND ALL CONTENT AND SERVICES PROVIDED UNDER THIS AGREEMENT
          OR THROUGH THE PLATFORM, WHETHER IN CONTRACT OR TORT OR OTHERWISE,
          WILL NOT EXCEED $10 OR, IN THE CASE OF YOU HAVE PAID FEES TO COMPANY
          TO ACCESS THE PLATFORM OR ANY CONTENT OR SERVICES, THE AMOUNTS PAID BY
          YOU TO COMPANY IN THE THREE (3) MONTH PERIOD PRECEDING THE EVENTS
          GIVING RISE TO ANY LIABILITY. YOU AGREE THAT COMPANY WOULD NOT ENTER
          INTO THIS AGREEMENT WITHOUT THESE LIMITATIONS ON ITS LIABILITY. IN
          JURISDICTIONS WHERE LIMITATION OF LIABILITY FOR CONSEQUENTIAL OR
          INCIDENTAL DAMAGES IS NOT PERMITTED, COMPANY’S LIABILITY IS LIMITED TO
          THE MAXIMUM EXTENT PERMITTED BY LAW.
        </p>

        <p>
          16. Data Privacy. You expressly consent to the use and disclosure of
          your personally identifiable information and other data and
          information as described in the Privacy Policy. Notwithstanding
          anything in the Privacy Policy, Company will have the right to
          collect, extract, compile, synthesize, and analyze non-personally
          identifiable data or information (data or information that does not
          identify an entity or natural person as the source thereof) resulting
          from Your access to and use of the Platform, Services or Content. To
          the extent any such non-personally identifiable data or information is
          collected or generated by Company, the data and information will be
          solely owned by Company and may be used by Company for any lawful
          business purpose without a duty of accounting to You, provided that
          the data and information is used only in an aggregated form, without
          directly identifying You or any other entity or natural person as a
          source thereof.
        </p>

        <p>
          17. Claims of Infringement. Company respects Your copyrights and other
          intellectual property rights and those of other third parties. If You
          believe in good faith that Your copyrighted work has been reproduced
          on the Platform without Your authorization in a way that constitutes
          copyright infringement, You may notify our designated copyright agent
          by mail to: Hire Next Generation LLC Attn: Copyright Infringement
          Agent 201 E. Pine Street, Suite 205 Orlando, Florida 32801 Please
          provide the following information to Company’s Copyright Infringement
          Agent: (1) the identity of the infringed work, and of the allegedly
          infringing work; (2) Your name, address, daytime phone number, and
          email address, if available; (3) a statement that You have a
          good-faith belief that the use of the copyrighted work is not
          authorized by the owner, his or her agent, or the law; (4) a statement
          that the information in the notification is accurate and, under
          penalty of perjury, that You are authorized to act on behalf of the
          owner; and (5) Your electronic or physical signature.
        </p>

        <p>
          18. Disputes. Except as otherwise provided below, the parties will
          attempt to resolve all disputes, controversies, or claims arising
          under, out of, or relating to this Agreement, including the formation,
          validity, binding effect, interpretation, performance, breach or
          termination, of this Agreement and the arbitrability of the issues
          submitted to arbitration hereunder and non-contractual claims relating
          to this Agreement (each, a “Dispute”), in accordance with the
          procedures set forth in this Section. If any Dispute cannot be
          resolved through negotiations between the parties within 5 days of
          notice from one party to the other of the Dispute, such Dispute will
          be finally settled through binding arbitration under the arbitration
          rules of the American Arbitration Association (“AAA”) then in effect
          (the “Rules”). Either party may commence the arbitration by delivering
          a request for arbitration as specified in the Rules. The arbitration
          will be conducted before a sole neutral arbitrator selected by
          agreement of the parties. If the parties cannot agree on the
          appointment of a single arbitrator within 30 days (the “Initial
          Period”) after either party to this Agreement delivers a request for
          arbitration, a neutral arbitrator will be selected as provided in the
          Rules. The arbitration will be conducted exclusively in the English
          language at a site specified by Company in Orange County, Florida
          U.S.A. The award of the arbitrator will be the exclusive remedy of the
          parties for all claims, counterclaims, issues, or accountings
          presented or pleaded to the arbitrator. The award of the arbitrators
          will require payment of the costs, fees, and expenses incurred by the
          prevailing party in any such arbitration by the non-prevailing party.
          Judgment upon the award may be entered in any court or governmental
          body having jurisdiction thereof. Any additional costs, fees or
          expenses incurred in enforcing the award may be charged against the
          party that resists its enforcement.
        </p>

        <p>
          19. Governing Law and Venue. The interpretation of the rights and
          obligations of the parties under this Agreement, including, to the
          extent applicable, any negotiations, arbitrations or other proceedings
          hereunder, will be governed in all respects exclusively by the laws of
          the State of Florida U.S.A. as such laws apply to contracts between
          Florida residents performed entirely within Florida without regard to
          the conflict of laws provisions thereof. Subject to Section 19
          (Disputes), each party will bring any action or proceeding arising
          from or relating to this Agreement exclusively in a federal court in
          the District of Florida, U.S.A. or in state court in Orange County,
          Florida U.S.A., and You irrevocably submit to the personal
          jurisdiction and venue of any such courts in any such action or
          proceeding brought in such courts by Company.
        </p>

        <p>
          20. Notices. Unless otherwise specified in this Agreement, any notices
          required or allowed under this Agreement will be provided to Company
          by postal mail to the address for Company listed on the Platform.
          Company may provide You with any notices required or allowed under
          this Agreement by sending You an email to any email address You
          provide to Company in connection with Your Account, provided that in
          the case of any notice applicable both to You and other Users of the
          Platform, Company may instead provide such notice by posting on the
          Platform. Notices provided to Company will be deemed given when
          actually received by Company. Notice provided to You will be deemed
          given 24 hours after posting to the Platform or sending via e-mail,
          unless (as to e-mail) the sending party is notified that the e-mail
          address is invalid.
        </p>

        <p>
          21. Linked Sites. The Platform may contain links to third-party sites
          or Content that are not under the control of Company. If you access a
          third-party site or Content from the Platform, then you do so at your
          own risk and Company is not responsible for any content on any linked
          site or content. You may establish a link to the Site, provided that
          the link does not state or imply any sponsorship or endorsement of
          Your site by Company or any group or individual affiliated with
          Company. You may not use on your site any Platform Content or marks
          appearing on the Platform in establishing the link. You may not frame
          or otherwise incorporate into another site the content or other
          materials on the Platform without prior written consent.
        </p>

        <p>
          22. Additional Terms. Unless otherwise amended as provided herein,
          this Agreement will exclusively govern Your access to and use of the
          Platform, including all Content and Services, and is the complete and
          exclusive understanding and agreement between the parties, and
          supersedes any oral or written proposal, agreement or other
          communication between the parties, regarding Your access to and use of
          the Platform, including all Content and Services. Except as expressly
          set forth in this Agreement, this Agreement may be amended or modified
          only by a writing signed by both parties. All waivers by Company under
          this Agreement must be in writing or later acknowledged by Company in
          writing. Any waiver or failure by Company to enforce any provision of
          this Agreement on one occasion will not be deemed a waiver by Company
          of any other provision or of such provision on any other occasion. If
          any provision of this Agreement is held to be unenforceable, that
          provision will be removed to the extent necessary to comply with
          applicable Law, replaced by a provision that most closely approximates
          the original intent and economic effect of the original to the extent
          consistent with the applicable Law, and the remaining provisions will
          remain in full force. The prevailing party in any lawsuit or
          proceeding arising from or related to this Agreement will be entitled
          to receive its costs, expert witness fees and reasonable attorneys’
          fees, including costs and fees on appeal. Neither this Agreement nor
          any rights or obligations of You hereunder may be assigned or
          transferred by You (in whole or in part and including by sale, merger,
          consolidation, or other operation of law) without the prior written
          approval of Company. Any assignment in violation of the foregoing will
          be null and void. Company may assign this Agreement to any party that
          assumes Company’s obligations hereunder. The parties hereto are
          independent parties, not agents, employees or employers of the other
          or joint venturers, and neither acquires hereunder any right or
          ability to bind or enter into any obligation on behalf of the other.
          Any reference herein to “including” will mean “including, without
          limitation.” Upon request from Company, You agree to provide Company
          with such documentation or records with respect to Your activities
          under this Agreement as may be reasonably requested for Company to
          verify Your compliance with the terms of this Agreement and all
          applicable Laws. The following Sections survive any expiration or
          termination of this Agreement: 1 (Definitions), 8 (Termination and
          Effect), 11 (Ownership), 12 (Representations and Warranties), 13
          (Disclaimers), 14 (Indemnity), 15 (Limitation on Liability), 16 (Data
          Privacy), 18 (Disputes), 19 (Governing Law and Venue), 20 (Notices)
          and 22 (Additional Terms).
        </p>
      </v-col>
    </v-row>
  </v-sheet>
</template>
<script>
export default {};
</script>

<style></style>
